import utils from '@/utils/utils'
import { AESEncrypt, AESDecrypt } from '@/utils/secret'
import serve from '@/api/api'
import router from '@/router'
/**
 * 获取字典名称
 * @param list  数组
 * @param dictValue  字典值
 */
export function getDictLabel(list, dictValue) {
	// const type = window.SITE_CONFIG['dictList'].find((element) => (element.dictType === dictType))
	// if (type) {
	const val = list.find((element) => (element.value === dictValue + ''))
	if (val) {
		return val.label
	} else {
		return dictValue
	}
	// } else {
	//   return dictValue
	// }
}
/**
 * 获取字典名称
 * @param list  数组
 * @param dictValue  字典值
 */
export function getDictLabelById(list, dictValue) {

	const val = list.find((element) => (element.id == dictValue + ''))

	if (val) {
		return val.dictLabel
	} else {
		return dictValue
	}

}
/**
 * 获取树形结构文本
 * @param list  数组
 * @param dictValue  字典值
 */
export function getTreeLabel(list, dictValue) {
	let arr = []

	function forFunc(list, dictValue) {
		dictValue.forEach((ele, idx) => {
			list.forEach((tree) => {
				if (ele == tree.value) {
					arr.push(tree.label)
					return
				}
				if (tree.children && tree.children.length > 0) {
					forFunc(tree.children, dictValue)
				}
			})
		})
	}
	forFunc(list, dictValue)

	return arr.join(' / ')
}


export function formatDate(timestamp, val) {
	if (timestamp) {
		// 将传入的字符串数字转换为数值，并乘以 1000 转换为毫秒级时间戳
		const numTimestamp = Number(timestamp) * 1000;
		if (isNaN(numTimestamp)) {
			// console.error('Invalid timestamp:', timestamp);
			return '_';
		}
		const date = new Date(numTimestamp);

		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const day = String(date.getDate()).padStart(2, '0');
		if (val == 1) {
			return `${year}年${month}月${day}日`;
		} else {
			return `${year}-${month}-${day}`;
		}
	}


}
//计算申报时间和申报状态
export function getsbTime(data) {
	var time = Date.parse(new Date()) / 1000;
	if (data.sbetime > time) {
		data.issb = 1;
		data.sbday = Math.ceil((data.sbetime - time) / (3600 * 24));
	}
	if (data.sbstime > time) {
		data.zt = 1;
	} else if (data.sbstime < time && data.sbetime > time) {
		data.zt = 2;
	} else if (data.sbetime < time) {
		data.zt = 3;
	}
	return data
}
export function getUUID() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
		return (c === 'x' ? (Math.random() * 16 | 0) : ('r&0x3' | '0x8')).toString(16)
	})
}
// 需求类别
export function getfwlbTypeName(index) {
	switch (index) {
		case 0:
			return '全部'
		case 1:
			return '采购需求'
		case 34:
			return '信息化服务'
		case 2:
			return '融资需求'
		case 3:
			return '服务需求'
		case 31:
			return '创业服务'
		case 32:
			return '人才培训'
		case 33:
			return '技术与质量服务'
		case 35:
			return '管理咨询服务'
		case 36:
			return '市场开拓服务'
		case 37:
			return '法律服务'
		case 38:
			return '其他服务'

	}
}
//机构的类别
export function getJgFwlb(index) {
	switch (index) {
		case 0:
			return '全部'
		case 2:
			return '投融资服务'
		case 3:
			return '创业服务'
		case 4:
			return '人才培训'
		case 5:
			return '技术与质量服务'
		case 1:
			return '信息化服务'
		case 6:
			return '管理咨询服务'
		case 7:
			return '市场开拓服务'
		case 8:
			return '法律服务'
		case 9:
			return '其他服务'
	}
}
export function getcpTypeName(value, options) {
	var Item = options.find(item => item.value == value)
	return Item.name
}
//将数据库中的带\的转义成数组
export function returnArry(value) {
	let data = null
	if (typeof value == 'string' && value !== '' && value !== null) {
		data = JSON.parse(value);
		returnArry(data)
	} else if (Array.isArray(value) && value.length !== 0) {
		data = JSON.parse(JSON.stringify(value));
	} else {
		data = []
	}
	return data
}

//获取公司类别联级
export function getgslbNew(val) {
	if (val) {
		const val0 = Number(val.split(',')[0])
		const val1 = Number(val.split(',')[1])
		let name1 = getName(utils.qylxList, val0)
		let name2 = getName(utils.qylxList, val1)
		function getName(arr, number) {
			let result = undefined;
			arr.find(item => {
				if (item.id == number) {
					result = item.name;
					return true
				} else if (item.children) {
					result = getName(item.children, number);
					return result !== undefined;
				}
			})
			return result;
		}
		return name1 + '/' + name2
		// return name1
	}
}
//获取企业的行业类型名称
export function gethylbLabel(val0, val1, cpListNew) {
	if (val0) {
		let name1 = getName(cpListNew, Number(val0))
		let name2 = getName(cpListNew, Number(val1))
		function getName(arr, number) {
			let result = undefined;
			arr.find(item => {
				if (item.value == number) {
					result = item.name;
					return true
				}
				else if (item.children) {
					result = getName(item.children, number);
					return result !== undefined;
				}
			})
			return result;
		}
		return name1 + '/' + name2
	}
}
// 下载需要token的文件
export function downloadFileByToken(filePath, fileName) {
	serve({
		url:`/file/stream/download?filePath=${filePath}&fileName=${filePath}`,
		method: 'GET',
		responseType: 'blob',
	}).then((res) => {
		const blob = new Blob([res]);
		const downloadUrl = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = downloadUrl;
		a.download = fileName;
		a.click();
		URL.revokeObjectURL(downloadUrl);
	}).catch((error) => {
		console.error('文件下载失败:', error);
		// 这里可以添加错误提示，比如使用element-ui的Message组件
		// Message.error('文件下载失败，请稍后重试');
	});
}
export function previewFileCheck(path,name){
	const fileExtension = path.substring(path.lastIndexOf('.') + 1).toLowerCase()
			if(['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp','pdf'].includes(fileExtension)){
				// 在新页面打开文件预览
				const routeData = router.resolve({
					path: '/fileAccess',
					query: {
						fileId: AESEncrypt(path),
						fileName: name,
						type:fileExtension,
						source:'wqqyfw',
					}
				});
				window.open(routeData.href, '_blank');
			}else{
				serve({
					url:`/file/stream/download?filePath=${AESEncrypt(path)}&fileName=${AESEncrypt(path)}`,
					method: 'GET',
					responseType: 'blob',
				}).then((res) => {
					const blob = new Blob([res]);
					const downloadUrl = URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = downloadUrl;
					a.download = name;
					a.click();
					URL.revokeObjectURL(downloadUrl);
				}).catch((error) => {
					console.error('文件下载失败:', error);
					// 这里可以添加错误提示，比如使用element-ui的Message组件
					// Message.error('文件下载失败，请稍后重试');
				});
			}
}
